export default {
  error: {
    time: '视频录制时长过短，请重新录制。',
    save: '保存失败',
    delete: '该资产已被删除，请重新选择。',
  },
  success: {
    msg: '录制保存成功',
    export: '导出任务已提交',
    delet: '删除成功',
    save: '保存成功',
    copy: '复制成功',
  },
  empty: {
    title: '该项目下暂无版本',
    desc: '立即创建版本，开始录制吧',
    add: '创建版本',
  },
  navbar: {
    backList: '返回录屏项目列表',
    record: '录屏编辑器',
    save: '保存',
    export: '导出',
    exportList: '导出列表',
  },
  left: {
    title: '产品&项目',
    projectInfo: {
      drop: '项目',
      add: '创建版本',
    },
    version: {
      title: '版本',
      copy: '复制',
      delete: '删除',
      copyDrop: {
        title: '复制版本',
        text: '版本名称',
      },
      delDrop: {
        title: '提示',
        text: '是否确认删除{versionname}版本',
      },
    },
  },
  work: {
    top: {
      again: '重新',
      start: '开始',
      record: '录制',
      finish: '完成录制',
      play: '录制回放',
      palying: '录制回放中',
      palyed: '回放已结束',
      againLoad: '重新加载',
    },
  },
  right: {
    recordParameter: '录屏参数',
    videoSet: '视频设置',
    videoSetting: {
      cursor: '录制光标',
      time: '显示时机',
      clickDisplay: '点击时显示',
      allDisplay: '一直显示',
      cursorSize: '光标尺寸',
      rotation: '旋转角度',
      image: '图片',
    },
  },
  exportList: {
    title: '版本导出历史',
  },
  imageUpload: {
    uploadRuleTips: {
      format: '图片文件格式',
      fileSize: '图片文件大小',
    },
  },
  PromptMessage: {
    assetNotFound: {
      title: '资源丢失',
      label: '项目中添加的资产已被删除。',
      continueLabel:
        '项目中添加的资产已被删除，导出会导致项目内容缺失，是否继续？',
    },
    pleaseEnter: '请输入',
  },
  rule: {
    createSuccess: '创建成功',
    nameLength: '名称长度在 20 个字符之间',
    size: '请选择尺寸',
    resolution: '请选择分辨率',
  },
}
